import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'orders',
    component: Children,

    children: [
      {
        path: '',
        name: 'orders',
        component: () => import('../pages/OrdersPage.vue')
      },
      {
        path: 'customer-order',
        component: Children,
        children: [
          {
            path: ':id',
            name: 'customer-order.show',
            component: () =>
              import('../pages/Customer/CustomerOrderShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':personId/create',
            name: 'customer-order.create',
            component: () =>
              import('../pages/Customer/CustomerOrderCreatePage.vue'),
            props: route => ({
              personId: Number(route.params.personId)
            })
          },
          {
            path: ':id/edit',
            name: 'customer-order.edit',
            component: () =>
              import('../pages/Customer/CustomerOrderEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'business-order',
        component: Children,
        children: [
          {
            path: ':id',
            name: 'business-order.show',
            component: () =>
              import('../pages/Business/BusinessOrderShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':companyId/create',
            name: 'business-order.create',
            component: () =>
              import('../pages/Business/BusinessOrderCreatePage.vue'),
            props: route => ({
              companyId: Number(route.params.companyId)
            })
          },
          {
            path: ':id/edit',
            name: 'business-order.edit',
            component: () =>
              import('../pages/Business/BusinessOrderEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'customer-order-repetitive',
        component: Children,
        children: [
          {
            path: ':id',
            name: 'customer-order-repetitive.show',
            component: () =>
              import('../pages/Repetitive/Customer/CustomerOrderShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':personId/create',
            name: 'customer-order-repetitive.create',
            component: () =>
              import(
                '../pages/Repetitive/Customer/CustomerOrderCreatePage.vue'
              ),
            props: route => ({
              personId: Number(route.params.personId)
            })
          },
          {
            path: ':id/edit',
            name: 'customer-order-repetitive.edit',
            component: () =>
              import('../pages/Repetitive/Customer/CustomerOrderEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'business-order-repetitive',
        component: Children,
        children: [
          {
            path: ':id',
            name: 'business-order-repetitive.show',
            component: () =>
              import('../pages/Repetitive/Business/BusinessOrderShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':companyId/create',
            name: 'business-order-repetitive.create',
            component: () =>
              import(
                '../pages/Repetitive/Business/BusinessOrderCreatePage.vue'
              ),
            props: route => ({
              companyId: Number(route.params.companyId)
            })
          },
          {
            path: ':id/edit',
            name: 'business-order-repetitive.edit',
            component: () =>
              import('../pages/Repetitive/Business/BusinessOrderEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      },
      {
        path: 'internal-order',
        component: Children,
        children: [
          {
            path: ':id',
            name: 'internal-order.show',
            component: () =>
              import('../pages/Internal/InternalOrderShowPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          },
          {
            path: ':companyId/create',
            name: 'internal-order.create',
            component: () =>
              import('../pages/Internal/InternalOrderCreatePage.vue'),
            props: route => ({
              companyId: Number(route.params.companyId)
            })
          },
          {
            path: ':id/edit',
            name: 'internal-order.edit',
            component: () =>
              import('../pages/Internal/InternalOrderEditPage.vue'),
            props: route => ({
              id: Number(route.params.id)
            })
          }
        ]
      }
    ]
  }
];

export default routes;
